<div class="bottom-sheet">
  <mat-nav-list class="bottom-sheet-list">
    <a
      class="bottom-sheet-list__item"
      mat-list-item 
      *ngFor="let optionItem of options.actions" 
      (click)="select($event, optionItem.choiceName)"
    >
      <span mat-line>
        <span *ngIf="!!optionItem.icon" [ngClass]="!!optionItem.icon ? optionItem.icon : ''" class="bottom-sheet-list__icon icon"></span>
        <span class="bottom-sheet-list__text">&nbsp; {{optionItem.text}}</span>
      </span>
    </a>
  </mat-nav-list>
  <mat-nav-list *ngIf="options.cancellable" class="bottom-sheet-list bottom-sheet-list--cancel">
    <a class="bottom-sheet-list__item" mat-list-item (click)="cancel()">
      <span mat-line>
        <span class="bottom-sheet-list__text">
          {{ 'common.cancel' | translate }}
        </span>
      </span>
    </a>
  </mat-nav-list>
</div>
